
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'editDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: 'edit' }) private type!: string
  @Prop({ default: () => { return {} } }) private node!: any
  private isDisableSubmit = false
  private formData = {
    id: 0,
    is_workday: 1
  }

  private rules = {
    is_workday: [
      { required: true, message: '请选择日期属性', trigger: 'blur' }
    ]
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.workdayAddDialog
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      if (this.type === 'edit') {
        this.formData = Object.assign({}, this.node)
      }
    }
  }

  // 提交按钮触发
  private handleSubmit(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isDisableSubmit = true
        if (this.type === 'add') {
          // this.addRequest()
        } else {
          this.editRequest()
        }
      } else {
        return false
      }
    })
  }

  // 新建保存
  // private addRequest() {
  //   CONFIGAPI.addworkday({
  //     name: this.formData.name
  //   }, {
  //     app_id: this.userCurrentApp
  //   }).then((res) => {
  //     if (res.stat === 1) {
  //       this.$message.success(res.data)
  //       ConfigModule.ToggleDialogStatus({
  //         name: 'workdayAddDialog',
  //         value: false
  //       })
  //       this.$emit('handleSuccess')
  //     }
  //     this.isDisableSubmit = false
  //   }).catch((error) => {
  //     console.log('发生错误！', error)
  //     this.isDisableSubmit = false
  //   })
  // }

  // 编辑保存
  private editRequest() {
    CONFIGAPI.editWrokday({
      is_workday: this.formData.is_workday,
      id: this.formData.id
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'workdayAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'workdayAddDialog',
      value: false
    })
  }
}
